<template>
    <div class="app_box">
        <my-header ref='header'></my-header>
        <div style="padding-top: 70px;">
            <!-- 筛选 -->
            <keyVue ref="Key" v-on:listenToChildEvent="getListType"></keyVue>
            <!-- 列表页面 -->
            <div :is="currentView" :ref='currentViewName'></div>
            <!-- </keep-alive> -->
            <!-- 悬浮工具 -->
            <InfoMenu></InfoMenu>
            <!-- 图例 -->
            <IconInfo  v-if="!thingjsxType && isRoutePageDisplay"></IconInfo>
            <div id="scrollToTop" class="scrollToTop right_bottom_corner fadeToTop" v-on:click="goScrollTop()">
                <img src="../../static/img/up.png" title="回到顶部" alt="">
            </div>
        </div>
        <!-- <div id="boxHeader">
            <CamanyInfoService @hidePanel="hidePanel" v-show="panelShow" :showPanel="showPanel"></CamanyInfoService>
        </div> -->
        <Footer/>
    </div>
</template>

<script>
    import myHeader from './Header2.vue';
    import keyVue from './Key.vue';
    import modelListVue from './ModelList.vue';
    import ShopScenesVue from './ShopScenes.vue';
    import ToolVue from './tool.vue';
    //import ToolVue from './tool1.vue';
    import ProjectListVue from './ProjectList.vue';
    import CityVue from './City.vue';
    import TopoVue from './Topos.vue';
    import zeroProjectsVue from './zeroProjects.vue';
    import ChartVue from './chart.vue';
    import DixVue from './dix.vue';
    import SenChartVue from './SenChart.vue';
    import SenEngineVue from './SenEngine.vue';
    // 低代码中的插件分类
    import lowCodePluginVue from './Plugins.vue';


    // import ProjectVIPListVue from './ProjectVIPList.vue';
    import InfoMenu from './InfoMenu.vue';
    import IconInfo from './IconInfo.vue';
    import VideosVue from './videos.vue';
    import CamanyInfoService from './CampanyInfo.vue';
    import allVue from './projectListAll.vue';
    import bus from '../assets/js/eventBus.js';

    // thingjs-x数据落地页
    // 项目
    import getProjectsVue from '../views/thingjsX/getProject/getProject.vue';
    // 插件
    import applicationVue from '../views/thingjsX/category/application.vue';
    import pluginsVue from '../views/thingjsX/category/plugin.vue';
    import interfaceTemplateVue from '../views/thingjsX/category/interfaceTemplate.vue';
    import layerPluginVue from '../views/thingjsX/category/layerPlugin.vue';
    import extendPluginVue from '../views/thingjsX/category/extendPlugin.vue';
    import corePluginVue from '../views/thingjsX/category/corePlugin.vue';
    import twinsPanelVue from '../views/thingjsX/category/twinsPanel.vue';
    import operatingAtomVue from '../views/thingjsX/category/operatingAtom.vue';
    import businessPluginVue from '../views/thingjsX/category/businessPlugin.vue';
    import sceneControlPluginVue from '../views/thingjsX/category/sceneControlPlugin.vue';
    import accessoriesPluginVue from '../views/thingjsX/category/accessoriesPlugin.vue';
    import chartPluginVue from '../views/thingjsX/category/chartPlugin.vue';
    import skinPluginVue from '../views/thingjsX/category/skinPlugin.vue';
    import otherPluginVue from '../views/thingjsX/category/otherPlugin.vue';
    import Footer from "./Footer.vue";
	export default {
        name: "index",
        components: {
            myHeader,
            keyVue,
            modelListVue,
            ShopScenesVue,
            ToolVue,
            ProjectListVue,
            CityVue,
            TopoVue,
            zeroProjectsVue,
            lowCodePluginVue,
            InfoMenu,
            IconInfo,
            VideosVue,
            CamanyInfoService,
            allVue,
            ChartVue,
            DixVue,
            SenChartVue,
            SenEngineVue,
            // thingjs-x数据
            // 项目
            getProjectsVue,
            // 插件
            applicationVue,
            pluginsVue,
            interfaceTemplateVue,
            layerPluginVue,
            extendPluginVue,
            corePluginVue,
            twinsPanelVue,
            operatingAtomVue,
            businessPluginVue,
            sceneControlPluginVue,
            accessoriesPluginVue,
            chartPluginVue,
            skinPluginVue,
            otherPluginVue,
            Footer
        },
		data: function() {
			return {
                currentView:"",
                currentViewName:"",
                panelShow:false,
                thingjsxTypeArr: [
                    "getProjects",
                    "plugins",
                    "interfaceTemplate",
                    "layerPlugin",
                    "extendPlugin",
                    "corePlugin",
                    "twinsPanel",
                    "operatingAtom",
                    "businessPlugin",
                    "sceneControlPlugin",
                    "accessoriesPlugin",
                    "chartPlugin",
                    "skinPlugin",
                    "otherPlugin",
                    "tools",
                    "topos",
                    "charts",
                    "dixs",
                    "senCharts"
                ],
                thingjsxType:'',
                isRoutePageDisplay: true // 如果页面为tools，则导航不显示
			};
        },
        watch: {
            // 判断排序是否显示（thingjs-x数据不显示）
            currentViewName(newVal){
                this.thingjsxType = this.thingjsxTypeArr.includes(newVal)
            },
        },
        methods:{
            getListType:function(data){
                switch(data){
                    case "models":
                        this.currentView = "modelListVue";
                        this.currentViewName = 'modelList';
                        break;
                    case "plugins":
                        this.currentView = "lowCodePluginVue";
                        this.currentViewName = 'lowCodePlugin';
                        break;
                    case "scenes":
                        this.currentView = "ShopScenesVue";
                        this.currentViewName = "ShopScenes";
                        break;
                    case "tools":
                        this.currentView = "ToolVue";
                        this.currentViewName = "Tool";
                        break;
                    case "projects":
                        this.currentView = "ProjectListVue";
                        this.currentViewName = "ProjectList";
                        break;
                    case "zeroProjects":
                        this.currentView = "zeroProjectsVue";
                        this.currentViewName = "zeroProjects";
                        break;
                    case "cities":
                        this.currentView = "CityVue";
                        this.currentViewName = "City";
                        break;
                    case "videos":
                        this.currentView = "VideosVue";
                        this.currentViewName = "Videos";
                        break;
                    case "all":
                        this.currentView = "allVue";
                        this.currentViewName = "all";
                        break;
                    case "topos":
                        this.currentView = "TopoVue";
                        this.currentViewName = "Topo";
                        break;
                    case "charts":
                        this.currentView = "ChartVue";
                        this.currentViewName = "Chart";
                        break;
                    case "dixs":
                        this.currentView = "DixVue";
                        this.currentViewName = "Dix";
                        break;
                    case "senCharts":
                        this.currentView = "SenChartVue";
                        this.currentViewName = "SenChart";
                        break;
                    case "senEngines":
                        this.currentView = "SenEngineVue";
                        this.currentViewName = "SenEngine";
                        break;
                    case "zeroCode":
                        this.currentView = "getProjectsVue";
                        this.currentViewName = "getProjects";
                        break;

                    case "zeroCode/getProjects":
                        this.currentView = "getProjectsVue";
                        this.currentViewName = "getProjects";
                        break;
                    case "zeroCode/plugins":
                        this.currentView = "pluginsVue";
                        this.currentViewName = "plugins";
                        break;
                    case "zeroCode/tools":
                        this.currentView = "ToolVue";
                        this.currentViewName = "tools";
                        break;
                    case "zeroCode/interfaceTemplate":
                        this.currentView = "interfaceTemplateVue";
                        this.currentViewName = "interfaceTemplate";
                        break;
                    case "zeroCode/layerPlugin":
                        this.currentView = "layerPluginVue";
                        this.currentViewName = "layerPlugin";
                        break;
                    case "zeroCode/extendPlugin":
                        this.currentView = "extendPluginVue";
                        this.currentViewName = "extendPlugin";
                        break;
                    case "zeroCode/corePlugin":
                        this.currentView = "corePluginVue";
                        this.currentViewName = "corePlugin";
                        break;
                    case "zeroCode/twinsPanel":
                        this.currentView = "twinsPanelVue";
                        this.currentViewName = "twinsPanel";
                        break;
                    case "zeroCode/operatingAtom":
                        this.currentView = "operatingAtomVue";
                        this.currentViewName = "operatingAtom";
                        break;
                    case "zeroCode/businessPlugin":
                        this.currentView = "businessPluginVue";
                        this.currentViewName = "businessPlugin";
                        break;
                    case "zeroCode/sceneControlPlugin":
                        this.currentView = "sceneControlPluginVue";
                        this.currentViewName = "sceneControlPlugin";
                        break;
                    case "zeroCode/accessoriesPlugin":
                        this.currentView = "accessoriesPluginVue";
                        this.currentViewName = "accessoriesPlugin";
                        break;
                    case "zeroCode/chartPlugin":
                        this.currentView = "chartPluginVue";
                        this.currentViewName = "chartPlugin";
                        break;
                    case "zeroCode/skinPlugin":
                        this.currentView = "skinPluginVue";
                        this.currentViewName = "skinPlugin";
                        break;
                    case "zeroCode/otherPlugin":
                        this.currentView = "otherPluginVue";
                        this.currentViewName = "otherPlugin";
                        break;




                    default:
                        this.currentView = "allVue";
                        this.currentViewName = "all";
                        break;
                }
            },
            UrlSearch:function(){
                var name,value;
                var obj={};
                var str= window.location.href;
                var num= str.indexOf("?")
                str = str.substr(num+1);
                var arr = str.split("&");
                for(var i=0;i < arr.length;i++){
                    num=arr[i].indexOf("=");
                    if(num>0){
                        name=arr[i].substring(0,num);
                        value=arr[i].substr(num+1);
                        obj[name]=value;
                    }
                }
                return obj;
            },
            initpathname:function(){
                var pathname = window.location.pathname;
                if(pathname!="/"){
                    switch(pathname){
                        case "/models":
                            this.currentView = "modelListVue";
                            this.currentViewName = 'modelList';
                            break;
                        case "/plugins":
                            this.currentView = "lowCodePluginVue";
                            this.currentViewName = 'lowCodePlugin';
                        break;
                        case "/scenes":
                            this.currentView = "ShopScenesVue";
                            this.currentViewName = "ShopScenes";
                            break;
                        case "/tools":
                            this.currentView = "ToolVue";
                            this.currentViewName = "Tool";
                            break;
                        case "/projects":
                            this.currentView = "allVue";
                            this.currentViewName = "all";
                            break;
                        case "/zeroProjects":
                            this.currentView = "zeroProjectsVue";
                            this.currentViewName = "zeroProjects";
                            break;
                        case "/":
                            this.currentView = "allVue";
                            this.currentViewName = "all";
                            break;
                        case "/cities":
                            this.currentView = "CityVue";
                            this.currentViewName = "City";
                            break;
                        case "/topos":
                            this.currentView = "TopoVue";
                            this.currentViewName = "Topos";
                            break;
                        case "/charts":
                            this.currentView = "ChartVue";
                            this.currentViewName = "Charts";
                            break;
                        case "/dixs":
                            this.currentView = "DixVue";
                            this.currentViewName = "Dixs";
                            break;
                        case "/senCharts":
                            this.currentView = "SenChartVue";
                            this.currentViewName = "SenCharts";
                            break;
                        case "/senEngines":
                            this.currentView = "SenEngineVue";
                            this.currentViewName = "SenEngines";
                            break;
                        case "/videos":
                            this.currentView = "VideosVue";
                            this.currentViewName = "Videos";
                            break;
                        case "/zeroCode":
                            this.currentView = "getProjectsVue";
                            this.currentViewName = "getProjectsVue";
                            break;
                        case "zeroCode/getProjects":
                            this.currentView = "getProjectsVue";
                            this.currentViewName = "getProjects";
                            break;
                        case "zeroCode/plugins":
                            this.currentView = "pluginsVue";
                            this.currentViewName = "plugins";
                            break;
                        case "zeroCode/tools":
                            this.currentView = "ToolVue";
                            this.currentViewName = "tools";
                            break;
                        case "zeroCode/interfaceTemplate":
                            this.currentView = "interfaceTemplateVue";
                            this.currentViewName = "interfaceTemplate";
                            break;
                        case "zeroCode/layerPlugin":
                            this.currentView = "layerPluginVue";
                            this.currentViewName = "layerPlugin";
                            break;
                        case "zeroCode/extendPlugin":
                            this.currentView = "extendPluginVue";
                            this.currentViewName = "extendPlugin";
                            break;
                        case "zeroCode/corePlugin":
                            this.currentView = "corePluginVue";
                            this.currentViewName = "corePlugin";
                            break;
                        case "zeroCode/twinsPanel":
                            this.currentView = "twinsPanelVue";
                            this.currentViewName = "twinsPanel";
                            break;
                        case "zeroCode/operatingAtom":
                            this.currentView = "operatingAtomVue";
                            this.currentViewName = "operatingAtom";
                            break;
                        case "zeroCode/businessPlugin":
                            this.currentView = "businessPluginVue";
                            this.currentViewName = "businessPlugin";
                            break;
                        case "zeroCode/sceneControlPlugin":
                            this.currentView = "sceneControlPluginVue";
                            this.currentViewName = "sceneControlPlugin";
                            break;
                        case "zeroCode/accessoriesPlugin":
                            this.currentView = "accessoriesPluginVue";
                            this.currentViewName = "accessoriesPlugin";
                        break;
                        case "zeroCode/chartPlugin":
                            this.currentView = "chartPluginVue";
                            this.currentViewName = "chartPlugin";
                            break;
                        case "zeroCode/skinPlugin":
                            this.currentView = "skinPluginVue";
                            this.currentViewName = "skinPlugin";
                            break;
                        case "zeroCode/otherPlugin":
                            this.currentView = "aotherPluginVue";
                            this.currentViewName = "otherPlugin";
                            break;
                        default:
                            this.currentView = "allVue";
                            this.currentViewName = "all";
                        break;
                    }
                }else{
                    this.initView();
                }
            },
            initView(){
                var url = window.location.href;
                var obj = this.UrlSearch(url);
                if(obj && obj.t){
                    switch(obj.t){
                        case "models":
                            this.currentView = "modelListVue";
                            this.currentViewName = 'modelList';
                            break;
                        case "/plugins":
                            this.currentView = "lowCodePluginVue";
                            this.currentViewName = 'lowCodePlugin';
                        break;
                        case "scenes":
                            this.currentView = "ShopScenesVue";
                            this.currentViewName = "ShopScenes";
                            break;
                        case "tools":
                            this.currentView = "ToolVue";
                            this.currentViewName = "Tool";
                            break;
                        case "projects":
                            this.currentView = "allVue";
                            this.currentViewName = "all";
                            break;
                        case "zeroProjects":
                            this.currentView = "zeroProjectsVue";
                            this.currentViewName = "zeroProjects";
                            break;
                        case "cities":
                            this.currentView = "CityVue";
                            this.currentViewName = "City";
                            break;
                        case "topos":
                            this.currentView = "TopoVue";
                            this.currentViewName = "Topo";
                            break;
                        case "charts":
                            this.currentView = "ChartVue";
                            this.currentViewName = "Chart";
                            break;
                        case "dixs":
                            this.currentView = "DixVue";
                            this.currentViewName = "Dix";
                            break;
                        case "senCharts":
                            this.currentView = "SenChartVue";
                            this.currentViewName = "SenChart";
                            break;
                        case "senEngines":
                            this.currentView = "SenEngineVue";
                            this.currentViewName = "SenEngines";
                            break;
                        case "videos":
                            this.currentView = "VideosVue";
                            this.currentViewName = "Videos";
                            break;
                        case "category":
                            this.currentView = "categoryVue";
                            this.currentViewName = "category";
                            break;
                        case "/zeroCode":
                            this.currentView = "getProjectsVue";
                            this.currentViewName = "getProjectsVue";
                            break;
                        case "zeroCode/getProjects":
                            this.currentView = "getProjectsVue";
                            this.currentViewName = "getProjects";
                            break;
                        case "zeroCode/plugins":
                            this.currentView = "pluginsVue";
                            this.currentViewName = "plugins";
                            break;
                        case "zeroCode/tools":
                            this.currentView = "ToolVue";
                            this.currentViewName = "tools";
                            break;
                        case "zeroCode/interfaceTemplate":
                            this.currentView = "interfaceTemplateVue";
                            this.currentViewName = "interfaceTemplate";
                            break;
                        case "zeroCode/layerPlugin":
                            this.currentView = "layerPluginVue";
                            this.currentViewName = "layerPlugin";
                            break;
                        case "zeroCode/extendPlugin":
                            this.currentView = "extendPluginVue";
                            this.currentViewName = "extendPlugin";
                            break;
                        case "zeroCode/corePlugin":
                            this.currentView = "corePluginVue";
                            this.currentViewName = "corePlugin";
                            break;
                        case "zeroCode/twinsPanel":
                            this.currentView = "twinsPanelVue";
                            this.currentViewName = "twinsPanel";
                            break;
                        case "zeroCode/operatingAtom":
                            this.currentView = "operatingAtomVue";
                            this.currentViewName = "operatingAtom";
                            break;
                        case "zeroCode/businessPlugin":
                            this.currentView = "businessPluginVue";
                            this.currentViewName = "businessPlugin";
                            break;
                        case "zeroCode/sceneControlPlugin":
                            this.currentView = "sceneControlPluginVue";
                            this.currentViewName = "sceneControlPlugin";
                            break;
                        case "zeroCode/accessoriesPlugin":
                            this.currentView = "accessoriesPluginVue";
                            this.currentViewName = "accessoriesPlugin";
                        break;
                        case "zeroCode/chartPlugin":
                            this.currentView = "chartPluginVue";
                            this.currentViewName = "chartPlugin";
                        break;
                        case "zeroCode/skinPlugin":
                            this.currentView = "skinPluginVue";
                            this.currentViewName = "skinPlugin";
                        break;
                        case "zeroCode/otherPlugin":
                            this.currentView = "aotherPluginVue";
                            this.currentViewName = "otherPlugin";
                        break;
                        default:
                            this.currentView = "allVue";
                            this.currentViewName = "all";
                        break;
                    }
                }else{
                    this.currentView = "allVue";
                    this.currentViewName = "all";
                }
            },
            goScrollTop(){
                (function smoothscroll(){
                    var currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
                    if (currentScroll > 0) {
                        window.requestAnimationFrame(smoothscroll);
                        window.scrollTo (0,currentScroll - (currentScroll/5));
                    }
                })();
            },
            //企业信息补全
            camInfoServer:function(res){
                var _this = this;
                var type = res;
                var toolInfo = '';
                if(res && res.type) type = res.type;
                if(res && res.toolInfo) toolInfo = res.toolInfo;
                // var havaOne = $.cookie("haveOne");
                $.ajax({
                    url: "https://store.thingjs.com/api/user/User_info?token="+$.cookie('token'),
                    type: 'get',
                    success: function (result){
                        var data = JSON.parse(result);
                        var openPage;
                        if(!data.phoneVerify) openPage = 'phone';
                        if(!data.office || !data.company || !data.namebyCam) openPage = openPage?openPage+'.info':'info';

                        if(type == "companyServerFirst"){
                            _this.showPanel();
                            data.type = type;
                            data.msg = {title:'注册',titleTip:'请填写您的完整信息，谢谢！',pages:openPage}
                            bus.$emit("openCampanyPanel",{infos:data});
                        }
                        // 埋点
                        // 设置用户属性
                        var userProperties = {
                            'userNick': data.userNick,
                            'namebyCam': data.namebyCam,
                            'company': data.company,
                            'office': data.office,
                            'phoneVerify': data.phoneVerify,
                            'registered_time': new Date(data.first_login),
                            'sex': data.sex,
                            'isregistered': '是',
                        }
                        data.vip_end === null ? '' : userProperties['vip_end'] = data.vip_end

                        // 账号关联
                        window.AnalysysAgent && window.AnalysysAgent.alias(data.mmdId + '')
                        window.AnalysysAgent && window.AnalysysAgent.profileSet(userProperties);

                        // 注册事件
                        if (data.login_times == 1) {
                            window.AnalysysAgent && window.AnalysysAgent.track('user_registered',{'$signup_time': new Date().toLocaleDateString()})
                        }

                    }
                });
            },
            setCookie:function(name, value, d, domain) {
                var Days = 1;
                if (d) Days = d;
                var exp = new Date();
                exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);

                var hostName = window.location.hostname;
                if(hostName == "store.thingjs.com") {
                    domain = ".thingjs.com";
                }else if(hostName == "www.3dmmd.cn") {
                    domain = ".3dmmd.cn";
                }

                if(domain){
                    document.cookie =name + "=" + escape(value) + ";domain="+domain+";expires=" + exp.toGMTString() + "; path=/;";
                }else{
                    document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString() + "; path=/";
                }
            },
            showPanel:function(){
                // if($.cookie('openid')){
                    this.panelShow = true;
                // }
            },
            hidePanel:function(success) {
                var _this = this;
                this.panelShow = false;
                window.parent.postMessage('closePanel','*');
            },
            // initSDK:function() {
            //     require('../assets/sdk/AnalysysAgent_JS_SDK.min.js') // 接入SDK
            //     require('../assets/sdk/AnalysysAgent_Encrypt.min.js') // 接入加密模块
            //     require('../assets/sdk/AnalysysAgent_GBK.min.js')  // 接入GBK转码模块SDK
            //     require('../assets/sdk/AnalysysAgent_PageViewStayTime.min.js')  // 页面访问时长模块SDK

            //     // 初始化JS SDK
            //     window.AnalysysAgent.init({
            //         appkey: "36a2d06e80f2df66",       //APPKEY
            //         debugMode: 0,
            //         uploadURL: 'https://www.thingjs.com/argo',
            //         visitorConfigURL: 'https://www.thingjs.com/argo', // 可视化
            //         /**如无自定义配置，则与uploadURL相同**/
            //         autoHeatmap: false,               // 点击位置热图、点击元素热图
            //         autoTrack: false,                 // 全埋点
            //         encryptType: 1,                   // 默认不加密0 加密1，2
            //         sendType:"post",
            //         // SDKFileDirectory: '../assets/sdk/',       //可视化模块SDK与热图模块SDK存放目录
            //         autoClickBlackList: function() {  //设置全埋点统计黑名单 页面地址`url`内包含'?m=sample'的页面不进行事件采集
            //             var url = window.location.href
            //             if(url.indexOf('?m=sample') > -1){
            //                 return true
            //             }
            //             return false
            //         },
            //     })
            //     $.cookie('mmdId') ? AnalysysAgent.alias($.cookie('mmdId')  + '') : ''
            // }
        },
        created:function(){
            if(this.$route.path == '/tools') this.isRoutePageDisplay = false;
            // var showCaminfo = window.localStorage.getItem('showCaminfo');
            var loginSource = window.localStorage.getItem('loginSource');
            if(!loginSource) return;
            if(loginSource == "companyServerFirst"){
                var data = {type:loginSource};
                this.camInfoServer(data);
                window.localStorage.removeItem('loginSource');
            }
        },
		mounted: function() {
            this.initpathname();
            // this.initSDK();
            // bus.$on("checkCampany",(data) => {
            //     this.camInfoServer(data);
            // });
            console.log("Welcome to the Resource center!");

		}
	};
</script>

<style>
    @import '../assets/css/modelList.css';
</style>



// WEBPACK FOOTER //
// src/components/Indexnew.vue